import { connect } from 'react-redux';
import PlacementData from '../../components/sections/pluginSettings/PlacementData';
import { updatePlacementData, updateBannerData } from '../../actions';

const mapStateToProps = state => {
  return {
    data: state.adData,
    configuration: state.configuration,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateState: data => {
      dispatch(updatePlacementData(data));
    },
    updateBannerState: data => {
      dispatch(updateBannerData(data));
    },
  };
};

const PlacementDataRedux = connect(mapStateToProps, mapDispatchToProps)(PlacementData);

export default PlacementDataRedux;
